export default __webpack_public_path__ + "static/media/portugal.c3698c6a.png";